import { nullishToOptional } from "../helpers";
import { z } from "zod";
//
// Base
//
export const PulsarPropertyType = z.enum([
    "string",
    "number",
    "boolean",
    "image",
    "enum",
    "color",
    "typography",
    "component",
    "componentProperties",
    "tokenProperties",
    "tokenType",
]);
export const PulsarBaseProperty = z.object({
    label: z.string(),
    key: z.string(),
    description: z.string().nullish(),
    type: PulsarPropertyType,
    values: z.array(z.string()).nullish(),
    default: z.union([z.string(), z.boolean(), z.number()]).nullish(), // PulsarPropertyValueType //is optional?
    inputType: z.enum(["code", "plain"]).optional(), //is optional?
    isMultiline: z.boolean().nullish(),
});
//
// Exporter custom properties
//
export const PulsarContributionConfigurationProperty = PulsarBaseProperty.extend({
    category: z.string(),
});
//
// Exporter custom blocks
//
export const PulsarContributionVariant = z.object({
    key: z.string(),
    name: z.string(),
    isDefault: nullishToOptional(z.boolean()),
    description: nullishToOptional(z.string()),
    thumbnailURL: nullishToOptional(z.string()),
});
export const PulsarCustomBlock = z.object({
    title: nullishToOptional(z.string()),
    key: z.string(),
    category: nullishToOptional(z.string()),
    description: nullishToOptional(z.string()),
    iconURL: nullishToOptional(z.string()),
    mode: nullishToOptional(z.enum(["array", "block"])),
    properties: nullishToOptional(z.array(PulsarBaseProperty)).transform((v) => v !== null && v !== void 0 ? v : []),
});
